export const ACCEPTED_FILE_EXTENSIONS = [".pptx"];
export const ACCEPTED_MIME_TYPES = new Set([
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]);
export const ACCEPTED_ARTICLE_FILE_EXTENSIONS = [".xlsx"];
export const ACCEPTED_ARTICLE_MIME_TYPES = new Set([
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
]);
